import React from 'react';

// tslint:disable max-line-length
const RIntroContentLocalPersonalTranscriptionDemo: React.FC = () => (
  <>
    <h5>Introduction</h5>
    <p>Hey. So you’re the one getting the gift. Lucky. I know someone has been thinking about you. If you want to just start walking, slowly, in any direction, I’ll explain. Ok? Someone you know has visited the museum. You were the lens for everything they looked at. They searched out things they thought you would care about and they took photos and made messages. When you open a part, walk around and see if you can find it. If you get stuck, show the photo to a member of staff. Someone’s gonna know where it is. I’ll see you on the other side.</p>
  </>
);

export {
  RIntroContentLocalPersonalTranscriptionDemo,
};
